import { ReactNode, useEffect } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { useTranslation } from "react-i18next";
import { PageTransition } from "@/components/PageTransition";
import { StickyMobileCart } from "@/components/StickyMobileCart";
import { DemoBanner } from "@/components/demo/DemoBanner";
import { DemoOnboardingWizard } from "@/components/demo/DemoOnboardingWizard";
import { DemoCompletionCelebration } from "@/components/demo/DemoCompletionCelebration";
import { DemoConversionCTA } from "@/components/demo/DemoConversionCTA";
import { useAuth } from "@/contexts/AuthContext";

export const Layout = ({ children }: { children: ReactNode }) => {
  const { isAdmin, staffRole } = useAuth();
  const { i18n } = useTranslation();
  const isStaffOrAdmin = isAdmin || !!staffRole;
  const isRTL = i18n.language === "ar";

  useEffect(() => {
    document.documentElement.dir = isRTL ? "rtl" : "ltr";
    document.documentElement.lang = i18n.language;
  }, [i18n.language, isRTL]);

  return (
    <PageTransition>
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 z-[100] bg-primary text-primary-foreground px-4 py-2 rounded-lg font-bold shadow-xl">
        Skip to content
      </a>
      <div className={`min-h-screen flex flex-col bg-background overflow-x-hidden w-full ${isRTL ? "font-arabic" : ""}`} dir={isRTL ? "rtl" : "ltr"}>
        <DemoBanner />
        {!isStaffOrAdmin && <DemoConversionCTA />}
        <Header />
        <main id="main-content" className="flex-1" role="main">{children}</main>
        <Footer />
        <StickyMobileCart />
        {!isStaffOrAdmin && <DemoOnboardingWizard />}
        {!isStaffOrAdmin && <DemoCompletionCelebration />}
      </div>
    </PageTransition>
  );
};